'use strict';

import _ from 'lodash';

const DateRangeVerifier = require('./DateRangeVerifier');

module.exports = DateRangeVerifier.define({
	type: 'DateOfBirthVerifier',

	lang: require('./DateOfBirthVerifierLang'),

	init: function(options) {
		this.DateRangeVerifier_init(
			_.defaults(options || {}, {
				minDate: moment().subtract(100, 'year'),
				maxDate: moment().subtract(4, 'year')
			})
		);
	}
});
